<template>
  <Menu/>
  <main id="home">
    <hero />
    <info />
    <process />
    <plans />
    <contact />
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Menu from '@/components/menu';
import hero from '@/components/hero';
import info from '@/components/info';
import process from '@/components/process';
import plans from '@/components/plans';
import contact from '@/components/contact'

export default {
  name: 'Home',
  data() {
    return {
    };
  },
  components: {
    Menu,
    hero,
    info,
    process,
    plans,
    contact
  },
};
</script>
